import useEventCallback from '@unifyapps/hooks/useEventCallback';
import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import { useAppDependencyGraphProvider } from '../../../../context/DependencyGraphProvider';
import { useGlobalAppStateStore } from '../../../../stores/app/GlobalAppStateStore';
import { ComputeContextKeys } from '../../../computeContext/const';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

function useSetLocalStorage() {
  const { setLocalStorage } = useGlobalAppStateStore().hooks.useActions();
  const { getNoCodeComputedData } = useGetNoCodeComputedData();
  const {
    actions: { notifyDependencyChange },
  } = useAppDependencyGraphProvider();

  const onSetLocalStorage: ActionHandlerType = useEventCallback(
    ({ action, actionContext }: OnActionArgs) => {
      const { payload } = action;

      const { value: computedPayload } = getNoCodeComputedData<{
        value: {
          operation: 'SET' | 'REMOVE' | 'CLEAR';
          key?: string;
          value?: unknown;
        };
      }>(
        {
          value: payload,
        },
        actionContext,
      );

      setLocalStorage({
        operation: computedPayload.operation,
        payload: {
          key: computedPayload.key,
          value: computedPayload.value,
        },
      });

      notifyDependencyChange({
        id: ComputeContextKeys.LOCAL_STORAGE,
      });

      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
  );

  return { onSetLocalStorage };
}

export default useSetLocalStorage;
